var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManifestSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1995 6.72168C27.9318 6.72168 27.6417 6.24708 27.5301 6.00977C27.4186 5.77247 27.1954 5.44025 27.1954 6.00977C27.1954 6.5793 26.7492 6.72168 26.526 6.72168C26.4145 6.72168 26.3252 6.79287 26.8607 7.07763C27.1108 7.11912 27.0465 7.55287 27.1954 7.78953C27.4455 8.18697 27.4186 7.67088 27.5301 7.43358C27.5301 7.31493 27.7802 7.11912 27.8648 7.07763C28.1995 6.95898 28.735 6.72167 28.1995 6.72168Z",
    fill: "url(#paint0_linear_2139_383)",
    stroke: "url(#paint1_linear_2139_383)",
    strokeWidth: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49753 4.74035C6.69426 4.9824 6.6831 5.33835 6.45997 5.6943C6.45997 5.12478 5.69017 4.7451 5.35547 4.62645C6.02486 4.62645 6.35956 3.91454 6.4265 3.55859C6.69426 4.41288 7.02895 4.2705 7.49753 4.74035Z",
    fill: "url(#paint2_linear_2139_383)",
    stroke: "url(#paint3_linear_2139_383)",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4046 16.8002C16.0658 16.4442 16.0658 15.3764 15.8315 14.9492C15.3964 16.8002 14.727 16.4442 14.0576 16.9069C15.7311 17.5121 15.3964 17.868 15.8315 18.7223C16.0993 17.5833 16.7352 17.1561 17.4046 16.8002Z",
    fill: "url(#paint4_linear_2139_383)",
    stroke: "url(#paint5_linear_2139_383)",
    strokeWidth: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7721 26.3398V26.3398C25.2366 27.7636 24.4333 27.8823 24.0986 27.7636C25.4374 28.3332 25.5177 28.6971 25.5177 28.8315C25.5177 29.1485 25.549 29.2112 25.7721 29.3298C25.7721 28.1908 26.7316 27.9748 27.1778 27.8562C25.7721 27.4077 25.7721 26.8144 25.7721 26.3398Z",
    fill: "url(#paint6_linear_2139_383)",
    stroke: "url(#paint7_linear_2139_383)",
    strokeWidth: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35948 27.7636C5.55621 27.1941 5.22151 26.5771 5.22151 26.3398C5.02069 27.4077 4.3513 27.4077 4.0166 27.7636C5.08763 27.7636 5.02069 28.4756 5.25498 28.9739C5.69009 27.4077 6.35948 27.7636 6.35948 27.7636Z",
    fill: "url(#paint8_linear_2139_383)",
    stroke: "url(#paint9_linear_2139_383)",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.983 2.67048C19.6289 1.40996 22.9908 4.37025 23.2771 6.04807C16.2425 2.75887 8.15873 11.7754 12.889 17.7131C11.9051 17.4695 9.5665 16.0752 8.08381 12.447C6.60111 8.81882 8.56639 5.09998 9.73436 3.69408C10.615 2.84934 12.699 1.17103 13.4129 0.932196C14.1131 0.697949 14.4455 0.739886 14.4455 0.739886C14.4061 1.09336 13.1853 1.76375 12.4327 3.6761C11.6801 5.58844 12.9358 5.20921 13.6399 4.93961L16.4211 4.17934C18.3454 3.84863 18.258 3.78914 18.2619 3.75379C18.2974 3.43567 16.7454 2.88616 15.983 2.67048Z",
    fill: "url(#paint10_linear_2139_383)",
    stroke: "url(#paint11_linear_2139_383)",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3196 30.2748C12.8387 31.9833 9.17231 29.4649 8.70215 27.8346C16.0521 30.2195 23.0807 20.2529 17.7256 14.9492C18.7297 15.0679 21.2064 16.1595 23.0807 19.5766C24.955 22.9937 23.4154 26.9329 22.4113 28.4754C21.6304 29.4246 19.7469 31.3523 19.0644 31.6789C18.395 31.9993 18.0603 31.9993 18.0603 31.9993C18.0603 31.6433 19.1982 30.8246 19.7338 28.8313C20.2693 26.838 19.0644 27.3719 18.395 27.7279L15.7174 28.8313C13.8431 29.4008 13.9365 29.449 13.9365 29.4846C13.9365 29.8049 15.5386 30.1561 16.3196 30.2748Z",
    fill: "url(#paint12_linear_2139_383)",
    stroke: "url(#paint13_linear_2139_383)",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43044 16.7819C1.20558 12.9185 3.95237 9.31108 5.52679 8.98838C2.51071 16.505 11.0763 25.0035 16.6077 19.9085C16.3893 20.9576 15.1038 23.4597 11.7086 25.0759C8.31339 26.6921 4.79542 24.6426 3.46084 23.4159C2.65701 22.4885 1.05633 20.2906 0.824006 19.534C0.596139 18.7919 0.631953 18.438 0.631953 18.438C0.964728 18.4761 1.60834 19.767 3.41458 20.5465C5.22081 21.3261 4.85059 19.9949 4.58944 19.249L3.84435 16.2996C3.51247 14.2568 3.45748 14.3505 3.4242 14.3467C3.1247 14.3124 2.62493 15.9688 2.43044 16.7819Z",
    fill: "url(#paint14_linear_2139_383)",
    stroke: "url(#paint15_linear_2139_383)",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9104 16.1798C30.2992 19.98 27.7096 23.7165 26.1506 24.115C28.8421 16.4603 19.9219 8.38488 14.6141 13.7421C14.7874 12.6836 15.9646 10.1219 19.2872 8.34316C22.6098 6.56439 26.2118 8.4416 27.5974 9.60255C28.4401 10.4901 30.1331 12.6083 30.3975 13.3529C30.6569 14.0832 30.6362 14.4385 30.6362 14.4385C30.3022 14.4165 29.604 13.1581 27.7663 12.4667C25.9286 11.7753 26.3554 13.0872 26.6482 13.8197L27.5186 16.73C27.9375 18.7546 27.9884 18.6584 28.0218 18.6606C28.3225 18.6804 28.7509 17.0014 28.9104 16.1798Z",
    fill: "url(#paint16_linear_2139_383)",
    stroke: "url(#paint17_linear_2139_383)",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90332 9.27808C8.90332 10.2273 9.0372 12.1969 9.57271 12.4816C9.46115 11.2951 9.17108 8.99331 8.90332 9.27808Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2139_383",
    x1: 27.4341,
    y1: 5.69531,
    x2: 27.4341,
    y2: 7.93524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2139_383",
    x1: 27.4341,
    y1: 5.69531,
    x2: 27.4341,
    y2: 7.93524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2139_383",
    x1: 6.4265,
    y1: 3.55859,
    x2: 6.4265,
    y2: 5.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2139_383",
    x1: 6.4265,
    y1: 3.55859,
    x2: 6.4265,
    y2: 5.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2139_383",
    x1: 15.7311,
    y1: 14.9492,
    x2: 15.7311,
    y2: 18.7223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2139_383",
    x1: 15.7311,
    y1: 14.9492,
    x2: 15.7311,
    y2: 18.7223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2139_383",
    x1: 25.6382,
    y1: 26.3398,
    x2: 25.6382,
    y2: 29.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2139_383",
    x1: 25.6382,
    y1: 26.3398,
    x2: 25.6382,
    y2: 29.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2139_383",
    x1: 5.18804,
    y1: 26.3398,
    x2: 5.18804,
    y2: 28.9739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2139_383",
    x1: 5.18804,
    y1: 26.3398,
    x2: 5.18804,
    y2: 28.9739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2139_383",
    x1: 14.2719,
    y1: 17.8876,
    x2: 16.4044,
    y2: 0.987052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2139_383",
    x1: 14.2719,
    y1: 17.8876,
    x2: 16.4044,
    y2: 0.987052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2139_383",
    x1: 16.333,
    y1: 14.9492,
    x2: 16.333,
    y2: 31.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2139_383",
    x1: 16.333,
    y1: 14.9492,
    x2: 16.333,
    y2: 31.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2139_383",
    x1: 16.7567,
    y1: 18.436,
    x2: 0.795607,
    y2: 16.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2139_383",
    x1: 16.7567,
    y1: 18.436,
    x2: 0.795607,
    y2: 16.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2139_383",
    x1: 14.5283,
    y1: 15.2203,
    x2: 30.5368,
    y2: 16.1505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2139_383",
    x1: 14.5283,
    y1: 15.2203,
    x2: 30.5368,
    y2: 16.1505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0240385,
    stopColor: "#AAD080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512019,
    stopColor: "#209499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08696D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManifestSvg);
export default __webpack_public_path__ + "static/media/manifestSVG.8c0a9801b15a4dc4d9a3bc72eda01262.svg";
export { ForwardRef as ReactComponent };